import {
  Icon,
  Loader,
  Price,
  SkeletonLoader,
  Text,
} from '@kanda-libs/ks-design-library';

import clsx from 'clsx';

import Container from './JobButton-container';
import { Bullets, JobModal } from './components';

import { ReactComponent as PDF } from '../../assets/mobile-pdf.svg';

export interface JobButtonProps {
  compact?: boolean;
}

const JobButton = ({ compact = false }: JobButtonProps) => (
  <Container>
    {({
      onClick,
      items,
      isLoading,
      title,
      total,
      onPdfClick,
      isSubmitting,
    }) => (
      <div className="relative w-full">
        <button
          type="button"
          onClick={onClick}
          disabled={isLoading}
          className={clsx(
            'flex flex-col w-full  border border-neutral-200 rounded-xl shadow-card',
            compact ? 'p-4' : 'px-4 py-5',
          )}
        >
          {!compact && (
            <div className="flex flex-row justify-between w-full mb-4">
              <Bullets items={items} isLoading={isLoading} />
              <Icon
                size={16}
                icon="chevron-right"
                className="ml-3"
                stroke="neutral-600"
              />
            </div>
          )}
          <div
            className={clsx(
              'flex flex-row justify-between w-full',
              !compact && 'min-h-22',
            )}
          >
            <div className="flex flex-col h-full text-left">
              <Text
                text={title}
                isLoading={isLoading}
                skeletonProps={{
                  width: 150,
                  count: 2,
                }}
                className={
                  compact ? 'text-16-20-em mb-1' : 'text-20-24-em mt-1 mb-3'
                }
              />
              <div className={clsx('flex flex-row', !compact && 'mt-auto')}>
                <Price
                  amount={total}
                  isLoading={isLoading}
                  poundsClassName={compact ? 'text-16-20-em' : 'text-20-24-em'}
                  centsClassName="text-10-14-em mt-px"
                />
                <Text
                  text="incl. VAT"
                  className="my-auto ml-1 text-purple-500 text-12-18"
                  isLoading={isLoading}
                  skeletonProps={{
                    width: 40,
                  }}
                />
              </div>
            </div>
            {!compact && <div className="w-16 min-w-16 ml-3" />}
          </div>
        </button>
        {!compact && (
          <button
            type="button"
            className="absolute w-16 top-14 right-4"
            onClick={onPdfClick}
            disabled={isLoading || isSubmitting}
          >
            <SkeletonLoader
              isLoading={isLoading || isSubmitting}
              afterLoading={<PDF />}
              width={64}
              height={86}
            />
          </button>
        )}
        <JobModal />
        <Loader isLoading={isSubmitting} />
      </div>
    )}
  </Container>
);

JobButton.displayName = 'JobButton-view';

export default JobButton;
